import React, { Component, useContext } from 'react'
import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'
import { UserDataContext } from '../auth/withAuth'
import ImpersonateUserMenu from './ImpersonateUserMenu'
import { reverse } from 'src/routes/config'
import './userMenu.scss'

const AvatarButton = React.forwardRef((props, ref) => {
    const user = useContext(UserDataContext)
    return (
        <Button {...props}>
            <div className={'user-data-wrapper'}>
                <span className={'user-first-last-name'}>
                    {user.data.firstName} {user.data.lastName}
                </span>
            </div>
            <Icon icon={'user-outline'} />
            <Icon className={'chevron-down'} icon={'chevron-down'} />
        </Button>
    )
})

export default class UserMenu extends Component {
    render() {
        return (
            <Dropdown className={'login-menu'} alignRight>
                <Dropdown.Toggle as={AvatarButton} id="user-dropdown-menu" />
                <Dropdown.Menu>
                    <ImpersonateUserMenu />
                    <Dropdown.Divider />
                    <Dropdown.Item href={reverse('logout')}>
                        Logout
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}
